import { useState } from "react";
import ClockInButton from "../ClockInButton";
import { FaWarehouse } from "react-icons/fa";
import ClockOutButton from "../ClockOutButton";
import TimeSinceDate from "../TimeSinceDate";

const GeofencedShopButton = ({ api, token, clockingData, setClockingData, clockBannerToShow, setClockBannerToShow, warehouses, buttonType = "in" }) => {
	const [showModal, setShowModal] = useState(false);

	const handleClick = (e) => {
		e.preventDefault();
		setShowModal(true);
	};

	return (
		<div>
			{showModal ? (
				<div className="fixed top-0 left-0 bg-black w-full h-full bg-opacity-40 flex justify-center items-center" onClick={() => setShowModal(false)}>
					<div className="bg-white p-3 rounded-lg" onClick={(e) => e.stopPropagation()}>
						<p className="font-bold text-3xl text-center mb-10">Select Warehouse</p>

						<div className="flex flex-col  items-center gap-4 h-[50vh] overflow-y-scroll">
							{warehouses && warehouses.length > 0
								? warehouses.map((mapData, index) => {
										return (
											<div key={mapData.id} className="flex flex-col items-center justify-between rounded-lg p-3 border border-black">
												<p className="text-xl mb-2 font-bold">{mapData.name}</p>
												<>
													<ClockInButton
														api={api}
														token={token}
														odooId={"000000SHOP"}
														odooModel={"project.task"}
														projectsRoute=""
														clockingData={clockingData}
														setClockingData={setClockingData}
														clockedIntoThis={true}
														showClock={false}
														clockBannerToShow={clockBannerToShow}
														setClockBannerToShow={setClockBannerToShow}
														warehouseData={mapData}
														hasGeofencing={true}
														projectLocation={{ lat: mapData.lat, lng: mapData.lng }}
													/>

													<ClockOutButton
														api={api}
														token={token}
														odooId={"000000SHOP"}
														odooModel={"project.task"}
														projectsRoute=""
														clockingData={clockingData}
														setClockingData={setClockingData}
														clockedIntoThis={true}
														showClock={false}
														clockBannerToShow={clockBannerToShow}
														setClockBannerToShow={setClockBannerToShow}
														warehouseData={mapData}
														hasGeofencing={true}
														projectLocation={{ lat: mapData.lat, lng: mapData.lng }}
													/>
												</>
											</div>
										);
								  })
								: null}
						</div>
						<button className="mt-2 bg-gray-500 hover:bg-gray-600 p-2 w-full text-white" onClick={() => setShowModal(false)}>
							Close
						</button>
					</div>
				</div>
			) : null}

			{clockingData && clockingData.lastClocked ? (
				<TimeSinceDate
					date={clockingData.lastClocked}
					preText={"Last action at"}
					setClockBannerToShow={setClockBannerToShow}
					specialCode={clockingData.specialCode}
				/>
			) : null}

			<button onClick={handleClick} className="p-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white w-full flex items-center gap-2">
				<FaWarehouse />
				{buttonType === "in" ? "Clock In To Shop" : "Clock Out Of Shop"}
			</button>
		</div>
	);
};

export default GeofencedShopButton;
